import { Module } from "./module";
import { TokenListObserver } from "@stimulus/mutation-observers";

var Router =
/** @class */
function () {
  function Router(application) {
    this.application = application;
    this.tokenListObserver = new TokenListObserver(this.element, this.controllerAttribute, this);
    this.modulesByIdentifier = new Map();
  }

  Object.defineProperty(Router.prototype, "schema", {
    get: function get() {
      return this.application.schema;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Router.prototype, "element", {
    get: function get() {
      return this.application.element;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Router.prototype, "controllerAttribute", {
    get: function get() {
      return this.schema.controllerAttribute;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Router.prototype, "modules", {
    get: function get() {
      return Array.from(this.modulesByIdentifier.values());
    },
    enumerable: true,
    configurable: true
  });

  Router.prototype.start = function () {
    this.tokenListObserver.start();
  };

  Router.prototype.stop = function () {
    this.tokenListObserver.stop();
  };

  Router.prototype.loadDefinition = function (definition) {
    var identifier = definition.identifier;
    this.unloadIdentifier(identifier);
    var module = new Module(this.application, definition);
    this.modulesByIdentifier.set(identifier, module);
    this.connectModule(module);
  };

  Router.prototype.unloadIdentifier = function (identifier) {
    var module = this.modulesByIdentifier.get(identifier);

    if (module) {
      this.disconnectModule(module);
      this.modulesByIdentifier.delete(identifier);
    }
  }; // Token list observer delegate

  /** @private */


  Router.prototype.elementMatchedTokenForAttribute = function (element, token, attributeName) {
    this.connectModuleForIdentifierToElement(token, element);
  };
  /** @private */


  Router.prototype.elementUnmatchedTokenForAttribute = function (element, token, attributeName) {
    this.disconnectModuleForIdentifierFromElement(token, element);
  };

  Object.defineProperty(Router.prototype, "contexts", {
    // Contexts
    get: function get() {
      return this.modules.reduce(function (contexts, module) {
        return contexts.concat(Array.from(module.contexts));
      }, []);
    },
    enumerable: true,
    configurable: true
  });

  Router.prototype.getContextForElementAndIdentifier = function (element, identifier) {
    var module = this.modulesByIdentifier.get(identifier);

    if (module) {
      return module.getContextForElement(element);
    }
  };

  Router.prototype.connectModule = function (module) {
    var elements = this.tokenListObserver.getElementsMatchingToken(module.identifier);

    for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
      var element = elements_1[_i];
      module.connectElement(element);
    }
  };

  Router.prototype.disconnectModule = function (module) {
    var contexts = module.contexts;

    for (var _i = 0, contexts_1 = contexts; _i < contexts_1.length; _i++) {
      var element = contexts_1[_i].element;
      module.disconnectElement(element);
    }
  };

  Router.prototype.connectModuleForIdentifierToElement = function (identifier, element) {
    var module = this.modulesByIdentifier.get(identifier);

    if (module) {
      module.connectElement(element);
    }
  };

  Router.prototype.disconnectModuleForIdentifierFromElement = function (identifier, element) {
    var module = this.modulesByIdentifier.get(identifier);

    if (module) {
      module.disconnectElement(element);
    }
  };

  return Router;
}();

export { Router };